import React, {useEffect, useState} from "react";
import { getWeather } from "../../services/WeatherService";
import useGlobal from "../../store";
import 'weather-icons/css/weather-icons.min.css'

const Weather = () =>  {
	const [weather, setWeather] = useState()
	const [currentState, currentActions] = useGlobal();


	useEffect(() => {
		if (!weather && currentState && currentState.site && currentState.site.site_id) {
			getWeather(currentState.site.site_id).then(response => {
				setWeather(response);
			}).catch(error => {
				setWeather({})
			})
		}
	}, [currentState])


	let icon = "weather-icon wi " + (weather && weather.weather ? 
				//This maintains compatibility for both the old and new Weather services
				//TODO: After migrating the database and external-data to the new weather table, clean out compatibility for the old weather service
				weather.weather[0].icon === "01d" ? "wi-day-sunny" :
				weather.weather[0].icon === "01n" ? "wi-night-clear" :
				weather.weather[0].icon === "02d" ? "wi-day-cloudy" :
				weather.weather[0].icon === "02n" ? "wi-night-alt-cloudy" : //few clouds
				weather.weather[0].icon === "03d" ? "wi-day-cloudy" :
				weather.weather[0].icon === "03n" ? "wi-night-cloudy" : //scattered clouds
				weather.weather[0].icon === "04d" ? "wi-day-cloudy" :
				weather.weather[0].icon === "04n" ? "wi-night-cloudy" : //broken clouds
				weather.weather[0].icon === "09d" ? "wi-day-showers" : //showers
				weather.weather[0].icon === "09n" ? "wi-night-showers" : //showers
				weather.weather[0].icon === "10n" ? "wi-day-cloudy" : //rain
				weather.weather[0].icon === "11d" ? "wi-day-storm-showers" : //thunderstorm
				weather.weather[0].icon === "11n" ? "wi-night-lightning" : //thunderstorm
				weather.weather[0].icon === "13d" ? "wi-day-snow" : //snow
				weather.weather[0].icon === "13n" ? "wi-night-snow" : //snow
				weather.weather[0].icon === "50d" ? "wi-day-fog" : //mist
				weather.weather[0].icon === "50n" ? "wi-night-fog" : //mist
				"" : weather ?
				weather.icon === "01d" ? "wi-day-sunny" :
				weather.icon === "01n" ? "wi-night-clear" :
				weather.icon === "02d" ? "wi-day-cloudy" :
				weather.icon === "02n" ? "wi-night-alt-cloudy" : //few clouds
				weather.icon === "03d" ? "wi-day-cloudy" :
				weather.icon === "03n" ? "wi-night-cloudy" : //scattered clouds
				weather.icon === "04d" ? "wi-day-cloudy" :
				weather.icon === "04n" ? "wi-night-cloudy" : //broken clouds
				weather.icon === "09d" ? "wi-day-showers" : //showers
				weather.icon === "09n" ? "wi-night-showers" : //showers
				weather.icon === "10n" ? "wi-day-cloudy" : //rain
				weather.icon === "11d" ? "wi-day-storm-showers" : //thunderstorm
				weather.icon === "11n" ? "wi-night-lightning" : //thunderstorm
				weather.icon === "13d" ? "wi-day-snow" : //snow
				weather.icon === "13n" ? "wi-night-snow" : //snow
				weather.icon === "50d" ? "wi-day-fog" : //mist
				weather.icon === "50n" ? "wi-night-fog" : //mist
				"" : "")
		
	let temp = weather && weather.main ? Math.round(weather.main.temp) : weather ? Math.round(weather.temp_f) : false
    return (
        <div className="weather">
            <div className={icon}></div>
            { weather && temp ? <div className="temp">{temp}&deg;</div> : <div className="temp"></div> }
			
        </div>

    )
}

export default Weather;
